import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// Dyeing
export const getPCsByIdSOD = async(IdSOD) => {
   const respuesta = await PrivateInterceptor(`Produccion/PC/byIdSOD/${IdSOD}`, 'GET')
   return respuesta;
}